// FAKE DATA
export const books = [
  {
    id: 1,
    title: "Crack the Coding Interview",
    summary:
      "A practical guide to technical interview preparation, problem solving, data structures, and communicating solutions clearly.",
    url: "https://m.media-amazon.com/images/I/61mIq2iJUXL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 49.95,
    salePrice: 14.95,
    rating: 4.5,
  },
  {
    id: 2,
    title: "Atomic Habits",
    summary:
      "A framework for building helpful habits and breaking unhelpful ones through small, consistent changes.",
    url: "https://m.media-amazon.com/images/I/81ANaVZk5LL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 39,
    salePrice: null,
    rating: 5,
  },
  {
    id: 3,
    title: "Can't Hurt Me",
    summary:
      "David Goggins shares lessons from his life about resilience, discipline, and pushing beyond self-imposed limits.",
    url: "https://m.media-amazon.com/images/I/81gTRv2HXrL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 29,
    salePrice: null,
    rating: 5,
  },
  {
    id: 4,
    title: "Deep Work",
    summary:
      "An argument for focused, distraction-free work as a way to master difficult skills and produce meaningful results.",
    url: "https://m.media-amazon.com/images/I/91nujEwIpYL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 44,
    salePrice: 19,
    rating: 4.5,
  },
  {
    id: 5,
    title: "The 10X Rule",
    summary:
      "A guide to setting ambitious goals and applying sustained effort to business and personal growth.",
    url: "https://m.media-amazon.com/images/I/71hjq42hvGL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 32,
    salePrice: null,
    rating: 5,
  },
  {
    id: 6,
    title: "Sell Or Be Sold",
    summary:
      "A sales-focused guide to persuasion, communication, and developing confidence in selling ideas and products.",
    url: "https://m.media-amazon.com/images/I/616OvChM3RL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 70,
    salePrice: 12.5,
    rating: 5,
  },
  {
    id: 7,
    title: "Rich Dad Poor Dad",
    summary:
      "Introduces contrasting approaches to money, assets, liabilities, and financial education through personal stories.",
    url: "https://m.media-amazon.com/images/I/81bsw6fnUiL.jpg",
    originalPrice: 11,
    salePrice: 10,
    rating: 4,
  },
  {
    id: 8,
    title: "Cashflow Quadrant",
    summary:
      "Explores four approaches to earning income and how mindset and financial choices shape each path.",
    url: "https://m.media-amazon.com/images/I/71+SWQ6xj1L._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 38,
    salePrice: 17.95,
    rating: 4.5,
  },
  {
    id: 9,
    title: "48 Laws of Power Summary",
    summary:
      "A concise overview of strategic principles related to influence, power dynamics, and decision making.",
    url: "https://m.media-amazon.com/images/I/611X8GI7hpL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 35,
    salePrice: 19.95,
    rating: 4.5,
  },
  {
    id: 10,
    title: "The 5 Second Rule",
    summary:
      "A simple countdown technique intended to interrupt hesitation and help turn intentions into action.",
    url: "https://m.media-amazon.com/images/I/91wOERyhh7L._UF1000,1000_QL80_.jpg",
    originalPrice: 40,
    salePrice: null,
    rating: 5,
  },
  {
    id: 11,
    title: "How to Win Friends & Influence People",
    summary:
      "Practical principles for communicating with empathy, building relationships, and influencing others constructively.",
    url: "https://m.media-amazon.com/images/I/71vK0WVQ4rL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 30,
    salePrice: 20,
    rating: 5,
  },
  {
    id: 12,
    title: "Mastery",
    summary:
      "Examines how expertise develops through long-term practice, mentorship, and focused learning.",
    url: "https://m.media-amazon.com/images/I/51V3121nmkL._AC_UF1000,1000_QL80_.jpg",
    originalPrice: 30,
    salePrice: 12.95,
    rating: 4.5,
  },
];
